import React from 'react';
import { string, number } from 'prop-types';

import * as helpers from './helpers';

const FillUserIcon = ({ color, fillOpacity, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <path
      fill={color}
      fillOpacity={fillOpacity}
      d="M3.3125 3.60419C3.3125 5.36156 4.74262 6.79169 6.5 6.79169C8.25737 6.79169 9.6875 5.36156 9.6875 3.60419C9.6875 1.84681 8.25737 0.416687 6.5 0.416687C4.74262 0.416687 3.3125 1.84681 3.3125 3.60419ZM12.1667 13.875H12.875V13.1667C12.875 10.4332 10.6501 8.20835 7.91667 8.20835H5.08333C2.34917 8.20835 0.125 10.4332 0.125 13.1667V13.875H12.1667Z"
    />
  </svg>
);

FillUserIcon.propTypes = {
  fillOpacity: number,
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

FillUserIcon.defaultProps = {
  fillOpacity: 0.4,
  ...helpers.getDefaultIconDimensionsProps(14, 13),
};

export default FillUserIcon;






// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/fill-user.js